import { useFetcher } from '@remix-run/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Switch from '~/components/Forms/Switch';
import Typography from '~/components/Typography';

import type { OrganizationSubscription } from '~/interfaces/subscriber_preferences';

import useToast from '~/hooks/useToast';

import { usePreferencesContext } from '../../_context/usePreferencesContext';

interface Props {
  organizationSubscription: OrganizationSubscription;
}

const OrganizationSubscriptionPreference = ({ organizationSubscription }: Props) => {
  const [enabled, setEnabled] = useState(organizationSubscription.subscribed);
  const { subscription } = usePreferencesContext();
  const { t } = useTranslation('', {
    keyPrefix: 'preferences.organization_subscriptions',
  });

  const fetcher = useFetcher<{ toast: any }>();
  const fetcherData = fetcher.data;

  useToast(fetcherData?.toast);

  const handleChange = (checked: boolean) => {
    const newValue = checked === true;
    setEnabled(newValue);

    const formData = new FormData();
    formData.append('organization_subscription_success_message', t('toast.success'));
    formData.append('organization_subscription_error_message', t('toast.error'));
    formData.append('subscriber_id', subscription?.subscriber_id || '');
    formData.append('publication_id', organizationSubscription.publication_id);
    formData.append('subscribed', String(newValue));

    fetcher.submit(formData, {
      method: 'patch',
      action: '/update_subscriber_organization_subscription',
    });
  };

  return (
    <div className="flex flex-row items-center justify-between">
      <div className="flex flex-col w-2/3">
        <Typography as="p" size="sm" weight="medium" className="text-[#111827]">
          {organizationSubscription.name}
        </Typography>
        <Typography as="p" size="sm" className="font-medium text-[#374151]">
          {organizationSubscription.description}
        </Typography>
      </div>
      <Switch checked={enabled} onChange={handleChange} />
    </div>
  );
};

export default OrganizationSubscriptionPreference;
